import React, { useEffect, useState } from "react";
import api from "../api";
import { Col, Container, Row } from "shards-react";
import {
  CircularProgress,
  createMuiTheme,
  IconButton,
  MuiThemeProvider
} from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Axios from "axios";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: "0px 8px 0px 8px",
          fontSize: "0.73rem"
        }
      },
      MuiFormLabel: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiInputBase: {
        root: {
          fontSize: "0.75rem"
        }
      },
      MuiTypography: {
        body1: {
          fontSize: "0.75rem"
        }
      }
    }
  });

const columns = [
  {
    name: "id",
    label: "Id",
    options: {
      filter: false,
      sort: true,
      display: false
    }
  },
  {
    name: "client.business_name",
    label: "Cliente",
    options: {
      filter: true,
      filterType: "textField",
      sort: true,
      display: true
    }
  },
  {
    name: "vehicle.plate",
    label: "Patente",
    options: {
      filter: true,
      filterType: "textField",
      sort: true,
      display: true
    }
  },
  {
    name: "subcontact.firstname",
    label: "Contacto Nombre",
    options: {
      filter: true,
      filterType: "textField",
      sort: true,
      display: true
    }
  },
  {
    name: "subcontact.lastname",
    label: "Contacto Apellido",
    options: {
      filter: true,
      filterType: "textField",
      sort: true,
      display: true
    }
  },
  {
    name: "description",
    label: "Descripción",
    options: {
      filter: true,
      filterType: "textField",
      sort: true,
      display: true,
      customBodyRender: value => {
        if (!value) return "";
        return value.length > 50 ? value.substring(0, 50) + "..." : value;
      }
    }
  },
  {
    name: "Acciones",
    label: "",
    options: {
      filter: false,
      setCellHeaderProps: () => ({ align: "center" }),
      customBodyRender: (value, tableMeta, updateValue) => {
        const rowId = tableMeta.rowData[0];
        return (
          <div className="row" style={{ display: "block" }}>
            {rowId ? (
              <Fab
                color="primary"
                aria-label="view"
                variant="extended"
                style={{ boxShadow: "none", backgroundColor: "green" }}
                fontSize="small"
                className="MuiButtonBase-root MuiFab-sizeSmall mr-2"
                href={"/bookings/quote/" + rowId}
              >
                <EditIcon fontSize="small" />
              </Fab>
            ) : (
              ""
            )}
          </div>
        );
      }
    }
  }
];

const BookingQuotes = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const getQuotes = async () => {
    const token = localStorage.getItem("userToken");
    return Axios.get(api.bookings().quotes(), {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        setQuotes(res.data);
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  };
  useEffect(() => {
    getQuotes();
  }, []);

  const options = {
    print: false,
    responsive: "stacked",
    selectableRowsOnClick: true,
    download: false,
    rowsPerPage: 10,
    textLabels: {
      toolbar: {
        search: "Buscar",
        viewColumns: "Ver columnas",
        filterTable: "Filtros",
        downloadCsv: "Exportar XLS"
      },
      body: {
        noMatch: loading ? "No hay resultados" : <CircularProgress />
      },
      selectedRows: {
        text: "fila(s) seleccionadas"
      },
      viewColumns: {
        title: "Ver columnas"
      },
      pagination: {
        next: "Siguiente",
        previous: "Anteior",
        rowsPerPage: "Cantidad por página:",
        displayRows: "de"
      },
      filter: {
        all: "Todos",
        title: "Filtros",
        reset: "Limpiar"
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={"Nueva"}>
            <IconButton
              onClick={e => {
                window.location.href = "/bookings/quote/0";
              }}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    }
  };

  return (
    <div>
      {loading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    title="Lista de Cotizaciones"
                    data={quotes}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};
export default BookingQuotes;
